module.exports = __webpack_public_path__ + "static/media/ic_small_arrow_up.329d690f.svg";